module.exports = __webpack_public_path__ + "static/img/Jack_Riewoldt_mobile.f76a78b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jack_Riewoldt_mobile.jpg
// module id = X0Po
// module chunks = 0